export const MAX_LEN_NAME = 50;

export const MAX_LEN_REASON = 65000;

export const MAX_LEN_TITLE = 100;

export const CODE_ERROR = {
  LIMIT_REACHED: "LIMIT_REACHED",
};
